import { PAGE_LEVEL } from '@/constants';

// 研报管理
export default {
  meta: { localeModules: ['report', 'aiChat', 'cloudDocument', 'summary'] },
  // 研报管理
  path: '/reportManage',
  redirect: '/reportManage/index',
  children: [
    {
      path: 'index',
      name: 'reportManage',
      component: () => import(/* webpackChunkName: 'report-manage' */ '@/pages/reportManage/index.vue'),
      meta: {
        name: 'routers.report_report',
        componentName: 'ReportListIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true
      }
    },
    {
      // 全局搜索的研报详情页面
      path: 'reportDetail',
      name: 'reportDetail',
      component: () => import(/* webpackChunkName: 'report-detail' */ '@/pages/reportManage/preview/index'),
      meta: {
        name: 'routers.report_report_detail',
        hiddenNav: true,
        parent: '/reportManage/index',
        otherParent: ['/find/list', '/find/self-selected', '/aiChat/index'],
        electronSingle: true,
        keepAlive: true
      }
    },
    {
      // 外资研报详情页面
      path: 'foreignCapitalReportDetail/:id',
      name: 'foreignCapitalReportDetail',
      component: () =>
        import(
          /* webpackChunkName: 'foreign-capital-report-detail' */ '@/pages/reportManage/foreignCapitalReportDetail/index'
        ),
      meta: {
        name: 'routers.report_foreign_capital_report_detail',
        parent: '/reportManage/index',
        otherParent: ['/find/list', '/find/self-selected'],
        electronSingle: true,
        dynamicTitle: true,
        keepAlive: false
      }
    },
    {
      // 外资研报 我的翻译
      path: 'myTranslate',
      name: 'myTranslate',
      component: () =>
        import(/* webpackChunkName: 'overseas-my-translate' */ '@/pages/reportManage/overseas/myTranslate'),
      meta: {
        name: 'routers.report_my_translate',
        parent: '/reportManage/index',
        electronSingle: true,
        keepAlive: true,
        pageLevel: PAGE_LEVEL.SECOND,
        hideOuterBreadcrumb: false
      }
    },
    {
      // 外资研报 我的解锁
      path: 'myUnlock',
      name: 'myUnlock',
      component: () => import(/* webpackChunkName: 'overseas-my-translate' */ '@/pages/reportManage/overseas/myUnlock'),
      meta: {
        name: 'routers.report_my_unlock',
        parent: '/reportManage/index',
        electronSingle: true,
        keepAlive: true,
        pageLevel: PAGE_LEVEL.SECOND,
        hideOuterBreadcrumb: false
      }
    },
    {
      // 内资研报详情页面
      path: 'domesticCapitalReportDetail/:id',
      name: 'domesticCapitalReportDetail',
      component: () =>
        import(
          /* webpackChunkName: 'viewpoint-and-domestic-capital-detail' */ '@/pages/reportManage/viewpointAndDomesticCapitalDetail/index'
        ),
      meta: {
        name: 'routers.report_domestic_capital_report_detail',
        parent: '/reportManage/index',
        otherParent: ['/find/list', '/find/self-selected', '/aiChat/index'],
        electronSingle: true,
        dynamicTitle: true,
        keepAlive: false,
        pageLevel: PAGE_LEVEL.SECOND,
        openNewPage: true,
        hideOuterBreadcrumb: true
      }
    },
    {
      // 观点详情页面
      path: 'viewpointDetail/:id',
      name: 'viewpointDetail',
      component: () =>
        import(
          /* webpackChunkName: 'viewpoint-and-domestic-capital-detail' */ '@/pages/reportManage/viewpointAndDomesticCapitalDetail/index'
        ),
      meta: {
        name: 'routers.report_viewpoint_detail',
        parent: '/reportManage/index',
        otherParent: ['/find/list', '/find/self-selected'],
        electronSingle: true,
        dynamicTitle: true,
        keepAlive: false
      }
    }
  ]
};
